import * as React from "react";
const SvgFiRrFlaskPoison = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-flask-poison_svg__a)">
      <path
        fill="#062147"
        d="M17.549 6.595A.99.99 0 0 1 17 5.71V2h1a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2h1v3.665a.99.99 0 0 1-.555.887C2.47 8.541 0 12.435 0 16.714c0 .979.13 1.95.387 2.887.709 2.59 3.089 4.398 5.79 4.398h11.646c2.701 0 5.081-1.809 5.79-4.398.257-.938.387-1.909.387-2.888 0-4.221-2.472-8.098-6.451-10.118m4.135 12.479C21.213 20.797 19.625 22 17.824 22H6.177c-1.802 0-3.39-1.203-3.86-2.926a9 9 0 0 1-.316-2.359c0-3.518 2.046-6.726 5.34-8.374a2.98 2.98 0 0 0 1.66-2.676V2h6v3.71c0 1.13.629 2.152 1.643 2.668 3.305 1.678 5.357 4.873 5.357 8.336 0 .8-.107 1.594-.317 2.36m-10.082-9.055c-2.078.202-3.601 2.07-3.601 4.158v1.822a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-2a4.005 4.005 0 0 0-4.399-3.981zm-1.353 5.231a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m3.492 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-flask-poison_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFlaskPoison;
